// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__XlTEg","header":"MessagesList_header__1zuLJ","chat":"MessagesList_chat__3okgZ"};